<template>
    <mdc-dialog v-model="isOpen"
                :title="'dro.report.header_mobile' | trans"
                :accept="'user.close' | trans"
                :cancel="'dro.cancel' | trans"
                @cancel="close"
                @accept="close"
                class="dro-report-dialog"
                :class="{'fullscreen-dialog' : isMobile}">
        <div v-if="!isMobile">

            <div class="close-cross" @click="close">
                <mdc-icon icon="close"></mdc-icon>
            </div>

            <div class="row">
                <div class="col">
                    <p class="gray-dark-sm">{{'dro.report.date' | trans}}:</p>
                    <p class="gray-700">{{date}}</p>
                </div>
                <div class="col">
                    <p class="gray-dark-sm">{{'dro.report.client' | trans}}:</p>
                    <p class="gray-700">{{assignee.code}}</p>
                </div>
                <div class="col">
                    <p class="gray-dark-sm">{{auditor.role}}</p>
                    <p class="gray-700">{{auditor.name}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="gray-dark-sm">{{'dro.parameters' | trans}}:</p>
                    <p class="gray-700">{{settings.aimTypeId | aimType}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="gray-dark-sm">{{'dro.behaviour_description' | trans}}:</p>
                    <p class="gray-700">{{behaviourDescription}}</p>
                </div>
            </div>
            <div class="row">
                <table class="table table-sm">
                    <thead class="thead-light">
                    <tr>
                        <th>{{'dro.report.interval_count' | trans}}</th>
                        <th>{{'dro.report.successful_interval_count' | trans}}</th>
                        <th>{{'dro.report.success_rate' | trans}}</th>
                        <th>{{'dro.report.failed_interval_count' | trans}}</th>
                        <th>{{'dro.report.fail_rate' | trans}}</th>
                        <th>{{'dro.report.average_successful_interval_duration' | trans}}</th>
                    </tr>
                    </thead>
                    <tbody class="gray-700">
                    <tr>
                        <td>{{intervalCount}}</td>
                        <td>{{successfulIntervalCount}}</td>
                        <td>{{successRate | percent}}</td>
                        <td>{{failedIntervalCount}}</td>
                        <td>{{failRate | percent}}</td>
                        <td>{{(averageSuccessfulIntervalDuration || '-') | minutes}}</td>
                    </tr>
                    </tbody>
                </table>

            </div>

        </div>

        <div v-else>
            <mdc-toolbar slot="toolbar"
                         class="navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-0 mb-md-4">
                <div class="container">
                    <!--  toolbar markup here -->
                    <mdc-toolbar-row>
                        <mdc-toolbar-section shrink-to-fit>
                            <span @click="close()">
                                <mdc-icon icon="close"></mdc-icon>
                            </span>
                            <h3 class="title">{{'dro.report.header_mobile' | trans}}</h3>
                        </mdc-toolbar-section>
                        <mdc-toolbar-section align-end>
                            <button class="btn btn-link" @click.prevent="close">{{'user.close' | trans}}
                            </button>
                        </mdc-toolbar-section>
                    </mdc-toolbar-row>
                </div>
            </mdc-toolbar>
            <div class="mobile-table">
                <div class="mobile-table__body">
                    <div class="mobile-table__row mx-0">
                        <div class="description pt-2">
                            <div>
                                <p class="gray-dark head">{{'dro.report.interval_count' | trans}}</p>
                                <p class="p-2 gray-700">{{intervalCount}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'dro.report.successful_interval_count' | trans}}</p>
                                <p class="p-2 gray-700">{{successfulIntervalCount}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'dro.report.success_rate' | trans}}</p>
                                <p class="p-2 gray-700">{{successRate | percent}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'dro.report.failed_interval_count' | trans}}</p>
                                <p class="p-2 gray-700">{{failedIntervalCount}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'dro.report.fail_rate' | trans}}</p>
                                <p class="p-2 gray-700">{{failRate | percent}}</p>
                            </div>

                            <div>
                                <p class="gray-dark head">{{'dro.report.average_successful_interval_duration' |
                                    trans}}</p>
                                <p class="p-2 gray-700">{{(averageSuccessfulIntervalDuration || '-') | minutes}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </mdc-dialog>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import Constants from '../Constants';
  import lang from '../../../lang/translator';

  export default {
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        disabled: false,
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {},
      },
      ...mapState('dro/session', [
        'auditor',
        'assignee',
        'intervals',
        'settings',
        'startedAt',
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      date() {
        let date = new Date();
        let day = date.getDate();
        if (day < 10) {
          day = `0${day}`;
        }
        let month = date.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }
        return `${day}.${month}.${date.getFullYear()}`;
      },
      behaviourDescription() {
        return this.settings.behaviourDescription || lang.get('export.reports.dro.not_specified');
      },
      intervalCount() {
        return this.intervals.length;
      },
      successfulIntervals() {
        let isAimPresence = parseInt(this.settings.aimTypeId) === Constants.AIM_TYPE_PRESENCE;
        return this.intervals.filter(
            (interval) => isAimPresence
                ? interval.behaviourHappenedAt !== null
                : interval.behaviourHappenedAt === null,
        );
      },
      successfulIntervalCount() {
        return this.successfulIntervals.length;
      },
      failedIntervalCount() {
        return this.intervalCount - this.successfulIntervalCount;
      },
      successRate() {
        if (!this.intervalCount) {
          return 0;
        }
        return Math.round((this.successfulIntervalCount / this.intervalCount) * 100);
      },
      failRate() {
        if (!this.intervalCount) {
          return 0;
        }
        return 100 - this.successRate;
      },
      averageSuccessfulIntervalDuration() {
        let totalDuration = this.successfulIntervals.map(
            (interval) => interval.behaviourHappenedAt !== null
                ? interval.behaviourHappenedAt
                : interval.duration,
        ).reduce((sum, duration) => sum + duration, 0);
        return Math.round(totalDuration / this.successfulIntervalCount);
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/ReportModal.vue